export default __webpack_public_path__ + "static/media/play_icon.29a65f51.svg";